import type { DatasetFormEditorProps } from "./dataset-form-editor.type";

import FormViewer from "@/components/FormEngine/Viewer";

import { useDatasetFormEditor } from "./dataset-form-editor.hook";

import "./dataset-form-editor.style.less";

export const DatasetFormEditor = (props: DatasetFormEditorProps) => {
  const { disabled, datasetsImage, datasetsImageLoading } = props;
  const { form, initialValues, schema, onFormChange } =
    useDatasetFormEditor(props);

  return (
    <FormViewer
      disabled={disabled}
      formParams={{
        form,
        initialValues,
        className: "dataset-form-editor",
      }}
      schema={schema}
      datasetsImage={datasetsImage}
      datasetsImageLoading={datasetsImageLoading}
      handleChange={onFormChange}
      strongLabel={false}
    />
  );
};
